import React from 'react';
import { useSelector } from 'react-redux';

const MfaError = () => {
	const { error } = useSelector((state) => state.authSlice.challenge);

	return error ? <p>{error}</p> : null;
};

MfaError.propTypes = {};

export default MfaError;
